import React from 'react';
import styles from '../../styles/ProductBadges.module.scss';
import { assetUrl } from '../../utils/imageUrl';
import { getProductGifts, hasFreeDelivery, hasProductGift } from '../../utils/productBadges';
import ProductImage from '../common/ProductImage';

const DeliveryTruckIcon = () => (
  <svg
    className={styles.deliveryTruckIcon}
    viewBox="0 0 24 24"
    width="16"
    height="16"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M3 6.5A1.5 1.5 0 0 1 4.5 5H14a1 1 0 0 1 1 1v1h2.09a2 2 0 0 1 1.57.77l2.34 2.93A2 2 0 0 1 21 12.24V17a1 1 0 0 1-1 1h-1.05A2.5 2.5 0 0 1 15.5 21 2.5 2.5 0 0 1 13 18.5H8.5A2.5 2.5 0 0 1 6 21 2.5 2.5 0 0 1 3.5 18.5H3a1 1 0 0 1-1-1v-11Zm2 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm11 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM5 7v8h1.05A2.5 2.5 0 0 1 8.5 13H13V7H5Zm7 2h2.38l1.88 2.35H12V9Zm3 4.24V11h2.38l.62.78V13h-3Z"
    />
  </svg>
);

const DeliveryBadge = ({ catalog = false }) => (
  <span
    className={`${styles.badgeDelivery}${catalog ? ` ${styles.badgeDeliveryCatalog}` : ''}`}
    tabIndex={catalog ? -1 : 0}
    aria-label="Безкоштовна доставка"
    onMouseDown={(e) => e.preventDefault()}
    onClick={(e) => e.stopPropagation()}
  >
    <span className={styles.badgeDeliveryPill}>
      <span className={styles.badgeDeliveryText}>Безкоштовна доставка</span>
      <span className={styles.badgeDeliveryIcon}>
        <DeliveryTruckIcon />
      </span>
    </span>
  </span>
);

const GiftBadge = ({ gifts, showPreview = false }) => {
  const canPreview = showPreview && gifts.length > 0 && gifts.some((gift) => gift.images?.[0]);

  return (
    <span
      className={`${styles.giftBadgeWrap}${canPreview ? ` ${styles.giftBadgeWrapInteractive}` : ''}`}
      tabIndex={canPreview ? 0 : -1}
      aria-label={canPreview ? 'Подарунок — наведіть для перегляду' : 'Подарунок'}
    >
      <span className={styles.badgeGift}>Подарунок</span>
      {canPreview && (
        <span className={styles.giftPreview} role="tooltip">
          {gifts.map((gift) => (
            gift.images?.[0] ? (
              <span key={gift.id} className={styles.giftPreviewItem}>
                <ProductImage src={assetUrl(gift.images[0])} alt={gift.title} width={72} height={72} />
                <span className={styles.giftPreviewTitle}>{gift.title}</span>
              </span>
            ) : null
          ))}
        </span>
      )}
    </span>
  );
};

const ProductBadges = ({ product, className = '', overlay = false, giftPreview = false }) => {
  const showGift = hasProductGift(product);
  const showFreeDelivery = hasFreeDelivery(product);
  const gifts = getProductGifts(product);

  if (!showGift && !showFreeDelivery) {
    return null;
  }

  return (
    <div
      className={`${styles.badges}${overlay ? ` ${styles.overlay}` : ''}${className ? ` ${className}` : ''}`}
    >
      {showGift && <GiftBadge gifts={gifts} showPreview={giftPreview} />}
      {showFreeDelivery && <DeliveryBadge catalog={giftPreview} />}
    </div>
  );
};

export default ProductBadges;
